import { createStyles, makeStyles, fade, Theme } from '@material-ui/core/styles';

import { colorsPalette, BIG_MARGIN, SMALL_MARGIN, MIDDLE_MARGIN, LARGE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      background: colorsPalette.blueDark,
      padding: `0 ${SMALL_MARGIN}px`,
      [theme.breakpoints.up('xl')]: {
        padding: '0 90px',
      },
    },
    footerContainer: {
      flex: 1,
      maxWidth: 1676,
    },
    footer: {
      padding: `${MIDDLE_MARGIN}px 0`,
      borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        padding: `${LARGE_MARGIN}px 0`,
      },
    },
    footerTitle: {
      color: colorsPalette.white,
      fontWeight: 700,
      fontSize: 18,
      lineHeight: 1.4,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        fontSize: 22,
        marginBottom: 30,
      },
    },
    footerPartners: {
      margin: 'auto',
      paddingBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginRight: MIDDLE_MARGIN,
      },
    },
    footerPartner: {
      display: 'inline-block',
      '&:not(:last-child)': {
        marginRight: 30,
        [theme.breakpoints.up('md')]: {
          marginRight: MIDDLE_MARGIN,
        },
      },
      '& > img': {
        height: 36,
        [theme.breakpoints.up('sm')]: {
          height: 42,
        },
        [theme.breakpoints.up('md')]: {
          height: 44,
        },
      },
    },
    footerNavigation: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
    },
    footerLinksBlock: {
      '&:not(:last-child)': {
        paddingRight: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingRight: LARGE_MARGIN,
        },
      },
    },
    footerLink: {
      display: 'block',
      color: colorsPalette.white,
      fontSize: 16,
      lineHeight: 1.4,
      marginBottom: 16,
      '&:hover': {
        textDecoration: 'none',
        color: colorsPalette.blue,
      },
    },
    bottomFooter: {
      padding: `${MIDDLE_MARGIN}px 0`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('sm')]: {
        padding: `${BIG_MARGIN}px 0`,
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
      },
    },
    license: {
      fontSize: 18,
      lineHeight: 1,
      color: colorsPalette.white,
    },
    socialLinks: {
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        marginBottom: 30,
      },
    },
    socialIcon: {
      '&:not(:first-child)': {
        marginLeft: SMALL_MARGIN,
      },
      '& > svg': {
        width: 24,
        height: 24,
      },
    },
  });
});
export default useStyles;
